'use client';

/* eslint-disable react/prop-types */

import React, { useState, useEffect } from 'react';
import navigationFallbackData from '../constants/globalnavdata.json';
import axios from 'axios';
import { Footer } from '@kbbsdk/global-sdk/navigation/web';
import HeaderContainer from './HeaderContainer.js';

// Base Container
export default function BaseContainer({
  // CLS Fix: Accept children instead of Component prop to support semantic layout
  children,
  // CLS Fix: Accept SSR navigation data to prevent late footer injection
  initialNavigation,
  ...pageProps
}) {
  const [navigationApiData, setNavigationApiData] = useState(initialNavigation || null);
  useEffect(() => {
    if (!navigationApiData) {
      const fetchGlobalNavData = async () => {
        try {
          const response = await axios.get('/api/psx-buy/global-nav-data');
          const navigation = response?.data;
          setNavigationApiData(navigation);
        } catch (error) {
          console.error('Error fetching navigations data:', error);
        }
      };
      fetchGlobalNavData();
    }
  }, [navigationApiData]);

  return (
    <>
      <HeaderContainer navigation={navigationApiData || navigationFallbackData} />
      {children}
      {/* CLS Fix: Always render Footer with fallback data instead of conditional rendering */}
      {/* This prevents the major ~0.919 CLS from late footer injection */}
      <Footer
        withToolbar
        navigation={navigationApiData || navigationFallbackData}
        nonBlueprintEmitAnalytics
        enableOneTrust
      />
    </>
  );
}
